<ng-template #verifyModal>
  <ng-container *ngIf="!isSSO">
    <div class="modal-body text-center h5 mt-3" [formGroup]="form">
      <p class="mb-2">Please enter password</p>
      <input type="password" class="form-control" formControlName="password" appValidationForm (keyup.enter)="onConfirm()">
    </div>

    <div class="modal-footer">
      <button class="btn btn-danger" (click)="onConfirm()" [ladda]="loading">Confirm</button>
    </div>
  </ng-container>

  <ng-container *ngIf="isSSO">
    <div class="modal-body text-center h5">
      <p class="mb-4">Please re-authenticate via Adecco Account</p>
      <button class="btn btn-danger" (click)="reAuthenticate()" [ladda]="loading">Re-authenticate</button>
    </div>
  </ng-container>
</ng-template>
